<template>
  <div class="product-page ggt-page">
    <div class="productBar">
      <div class="auto">
        <h2>产品：大智慧「启航版」<span>非投资咨询类软件产品</span></h2>
      </div>
    </div>
    <div class="top-mod">
      <div class="wrap">
          <h1>大智慧「启航版」<img src="../../assets/images/product/338/titleup.png" alt="" width="107.08px" height="67.53px"></h1>
          <p class="tip1">快速入门，炒股利器，纵横股海，一站式解决炒股难题</p>
          <p class="tip2">智能选股 · 专业指标 · 一网打尽</p>
          <p class="tip3">咨询热线：021-20219999</p>
          <div class="price">￥598 元/年 <del class="del">￥2180 元/年</del><span class="btn-buy" @click="goParkate">立刻购买</span></div>
      </div>
    </div>
    <div class="main">
      <div v-for="(row,rowindex) in pageData" class="row" :class="'row'+(rowindex+1)">
        <div class="ctn-box">
          <div class="title-box">
            <h3>{{row.title}}</h3>
            <p>{{row.titleBtm}}</p>
          </div>
          <div class="clearfix character-list" v-if="row.characterList" :class="'f'+row.characterList.length">
            <span class="ct-item" v-for="pitem in row.characterList">
              <p v-for="text in pitem">{{text}}</p>
            </span>
          </div>
          <div class="block">
            <el-carousel trigger="click" height="682px">
              <el-carousel-item v-for="(item,index) in row.carouselData" :key="index">
                <img :src="require('../../assets/images/product/338/carousel/c0'+(rowindex+1)+'/img'+item)"/>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>
    <float-bar :id="id" :month="month"/>
  </div>
</template>
<script>
import FloatBar from "@/components/product/FloatBar.vue";
export default {
  data() {
    return {
      id: this.$parent.id,
      month : 12,
      pageData:[
        {
          title:'主战系统',
          titleBtm:'主战系统是基于MACD3衍生的K线主图指标,系统自动在K线图上标注低位钝化、底背离、高位钝化、顶背离等关键信号,一目了然。',
          carouselData:['1.png','2.png','3.png','4.png','5.png']
        },
        {
          title:'分时决策先锋',
          titleBtm:'分时决策先锋是基于“量价背离理论”研发而成，为投资者提供了捕捉短期支撑压力位，评估全日股价波动区间的即时、无漂移(无未来函数)的分时决策支持。',
          carouselData:['1.png','2.png','3.png']
        },
        {
          title:'极速行情，全景看盘',
          titleBtm:'专业的看盘界面，只为更快更好的及至看盘体验',
          carouselData:['1.png','2.png','3.png']
        }, {
          title:'AI决策：四维战法',
          titleBtm:'通过对价量筹码资金等多种分析方法的融合。过滤单一指标发出失真信号的场景。',
          characterList:[
            ['黄金波段第一时间','揭示顶背离和底背离'],
            ['市场热度多空热度一手掌握'],
            ['GDX深度挖掘','活跃资金的市场行为'],
            ['黄金狙击变盘信号早知道']
          ],
          carouselData:['1.jpg','2.jpg','1.jpg','2.jpg']
        }, {
          title:'智能选股',
          titleBtm:'基本面、技术面、资金面、消息面；一句话、一个关键词即可全局搜索',
          carouselData:['1.png','2.png','1.png','2.png']
        }, {
          title:'新闻资讯数据全覆盖',
          titleBtm:'汇聚宏观行业政策、机构观点、主力资金动向、个股分析等高投资价值资讯数据。',
          characterList:[
            ['宏观、行业资讯、','个股F10、北向资金'],
            ['7*24小时不间断，','及时、专业的财经数据资讯'],
            ['个股公告研报秒更新']
          ],
          carouselData:['1.png','2.png','3.png']
        }, {
          title:'技术大讲堂',
          titleBtm:'软件功能不会用？哪里不会点哪里，视频详解产品热门功能',
          carouselData:['1.jpg','2.png','1.jpg','2.png']
        }
      ]
    };
  },
  created () {
    document.title = '大智慧启航版';
  },
  components:{
    FloatBar
  },
  methods: {
    goParkate () {
      this.$router.push("/order/confirm/338/12?s=official");
    }
  },
}
</script>
<style lang="scss" scoped>
$url:'../../assets/images/product/338/';
/deep/.product-page{
  .page-header{
    position: relative;
    img {
      display: block;
    }
  }
  .top-mod{
    width: 100%;
    height: 759px;
    background: url($url+'bg.jpg')no-repeat center /1920px;
    .wrap{
      width: 1200px;
      margin: 0 auto;
      padding-top: 115px;
      box-sizing: border-box;
      h1{
        font-size: 50px;
        line-height: 53px;
        color: #fff;
      }
      p{
        &.tip1{
          font-size: 24px;
          line-height: 24px;
          margin-top: 20px;color: #fff;
        }
        &.tip2{
		  display:inline-block;
          min-width: 501px;
          height: 50px;
          padding: 0 10px;
          border-radius: 50px;
          border: 1px solid #31cfff;
          font-size: 22px;
          text-align: center;
          box-sizing: border-box;
          line-height: 50px;
          color: #31cfff;
          margin-top: 35px;
          margin-bottom: 118px;
        }
        &.tip3{
          font-size: 22px;
          line-height: 22px;
          margin-bottom: 24px;
          color: #fff;
          padding-left: 30px;
          background: url($url+'icon-phone.png')no-repeat left center/22px;
        }
      }
      .price{
        width: 460px;
        height: 72px;
        border-radius: 6px;
        background-color: rgba(255,255,255,0.1);
        border: 1px solid #fff;
        box-sizing: border-box;
        font-size: 30px;color: #fff;
        line-height: 70px;
        text-align: left;
        padding-left: 20px;
        overflow: hidden;
        box-sizing: border-box;
        .del{
          font-size: 18px;
          color: #758bad;
          margin-left: 1px;
        }
      }
      .btn-buy{
        display: inline-block;
        width: 160px;
        height: 100%;
        color: #fff;
        text-align: center;
        float: right;
        cursor: pointer;
        background: url($url+'btnbg.png')no-repeat center/191px;
        &:hover{
          opacity: 0.85;
        }
      }
    }
  }
  .main {
    margin: 0 auto;
    padding: 0;
    .row {
      h3 {

      }
      .ctn-box{
        width: 1200px;
        margin: 0 auto;
        padding-bottom: 106px;
        .title-box{
          text-align: center;
          padding-top: 71px;
          h3{
            color: #222222;
            font-size: 40px;
            height: 58px;
            line-height: 40px;
            text-align: center;
            box-sizing: border-box;
            padding-top: 18px;
            background: url($url+'titlebg.png')no-repeat center/636px;
          }
          p{
            padding-top: 16px;
            font-size: 20px;
            color: #666666;
          }
        }
        .character-list{
          margin-top: 42px;
          margin-bottom: 44px;
          display: flex;
          .ct-item{
            width: 372px;
            height: 253px;
            border-radius: 10px;
            background-color: #fff;
            box-shadow: 0px 15px 40px rgba(0,0,0,0.2);
            padding-top: 27px;
            position: relative;
            box-sizing: border-box;
            display: inline-block;
            float: left;
            &:last-child{
              margin-right: 0;
            }

            margin-right: 42px;

            &:before{
              content: '';
              width: 120px;
              height: 120px;
              border-radius: 120px;
              display: block;
              margin: 0 auto 16px;
            }
            p{
              font-size: 20px;
              color: #30303f;
              text-align: center;
              line-height: 30px;
            }
          }
          &.f4{
            .ct-item{
              width: 278px;
              margin-right: 30px;
              &:last-child{
                margin-right: 0;
              }
            }
          }

        }
        .block{
          margin-top: 40px;
          .el-carousel{
            width: 1200px;
            height: 682px;
            border-radius: 6px;
            border: 4px solid #fff;
            box-shadow: 0px 15px 40px rgba(0,0,0,0.2);
            .el-carousel__item{
              img{
                width: 100%;
                height: 100%;
              }
            }
            .el-carousel__arrow{
              width: 85px;
              height: 85px;
              border-radius: 85px;
              background: transparentize(#555c6f, .7);
              i{
                font-size: 40px;
              }
              &:hover{
                background: transparentize(#555c6f, .6);
              }
            }
            .el-carousel__indicators{
              display: none;
            }
          }
        }
      }
      &.row2,&.row4{
        background: url($url+'bg2.jpg')no-repeat center/1920px;
        .ctn-box{
          padding-bottom: 95px;
        }
      }
      &.row2{
        .character-list{
          .ct-item{
            &:before{
              content: '';
              display: block;
              background-image: url($url+'icons1.png');
              background-size: 1042px;
              background-repeat: no-repeat;
            }
            &:nth-child(2){
              &:before{
                background-position: -313px 4px;
              }
            }
            &:nth-child(3){
              &:before{
                background-position: -617px -4px;
              }
            }
            &:nth-child(4){
              &:before{
                background-position: -923px 0px;
              }
            }
          }
        }
      }
      &.row4{
        .character-list{
          .ct-item{
            &:before{
              content: '';
              display: block;
              background-image: url($url+'icons2.png');
              background-size: 944px;
              background-repeat: no-repeat;
            }
            &:nth-child(2){
              &:before{
                background-position: -416px -4px;
              }
            }
            &:nth-child(3){
              &:before{
                background-position: -824px 0px;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/Product338.vue